var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.46154H0V1.15385H6V3.46154ZM6 6.92308H0V9.23077H6V6.92308ZM22.308 15L17.712 10.5808C16.752 11.1808 15.624 11.5385 14.4 11.5385C11.088 11.5385 8.4 8.95385 8.4 5.76923C8.4 2.58462 11.088 0 14.4 0C17.712 0 20.4 2.58462 20.4 5.76923C20.4 6.94615 20.028 8.03077 19.404 8.94231L24 13.3731L22.308 15ZM18 5.76923C18 3.86538 16.38 2.30769 14.4 2.30769C12.42 2.30769 10.8 3.86538 10.8 5.76923C10.8 7.67308 12.42 9.23077 14.4 9.23077C16.38 9.23077 18 7.67308 18 5.76923ZM0 15H12V12.6923H0V15Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.c4459707088c9787e37564e4cfba87ae.svg";
export { ForwardRef as ReactComponent };